import { useEffect, useRef } from 'react';

import type { Column } from '@tanstack/react-table';

import { Analytics } from '@cobliteam/analytics';

import ViewColumnIcon from '@mui/icons-material/ViewColumn';

import Button from '../../Button';
import DropdownMenu from '../../DropdownMenu';
import Typography from '../../Typography';

interface DataTableFilterColumnsProps<T> {
  columns: Column<T>[];
  visibleColumns: Column<T>[];
}

const DataTableFilterColumns = <T,>({
  visibleColumns,
  columns,
}: DataTableFilterColumnsProps<T>) => {
  const isFirstMount = useRef(true);
  const allVisibleColumns = visibleColumns.map(
    (column) => column.columnDef?.meta?.name
  );

  const onChangeColumnVisibility = (column: Column<T>) => {
    column.toggleVisibility(!column.getIsVisible());
  };

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
    } else {
      Analytics.track('DataTable Selected Columns Changed', {
        selectedColumns: allVisibleColumns,
      });
    }
  }, [JSON.stringify(allVisibleColumns)]);

  if (columns.length <= 2) return null;

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button
          startIcon={<ViewColumnIcon />}
          size='condensed'
          variant='outlined'
          color='secondary'
        >
          Colunas
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='start'>
        <DropdownMenu.Header>Filtrar Colunas</DropdownMenu.Header>
        <DropdownMenu.Separator />
        {columns
          .filter((column) => column.getCanHide())
          .map((column) => {
            return (
              <DropdownMenu.CheckboxItem
                key={column.id}
                checked={!!column.getIsVisible()}
                onCheckedChange={() => onChangeColumnVisibility(column)}
              >
                <Typography color='secondary'>
                  {column.columnDef.meta?.name}
                </Typography>
              </DropdownMenu.CheckboxItem>
            );
          })}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default DataTableFilterColumns;
